import { DatePicker, Pagination } from "antd";
import moment from "moment";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Select from "react-select";
import { ScaleLoader } from "react-spinners";
import { toast } from "react-toastify";
import {
  AddToCart,
  CreateOrder,
  DeleteItemFromCart,
  GetCart,
  Products,
  add_to_cart,
  del_from_cart,
  get_addresses,
  get_cart,
  get_origins,
  get_prod_filters,
  get_products,
  store_addr_details,
  clear_cart,
} from "../actions/orders";
import season from "../assets/all_season.png";
import close from "../assets/cancel.svg";
import classic from "../assets/classic.png";
import Tyre from "../assets/coming-soon.jpg";
import fuel from "../assets/fuel.png";
import highway from "../assets/highway.svg";
import Menu from "../assets/menu.svg";
import mud from "../assets/mud.png";
import no_sound from "../assets/no_sound.png";
import peak from "../assets/peak.png";
import rain from "../assets/rain.png";
import refresh from "../assets/refresh.svg";
import Search from "../assets/search.svg";
import sound from "../assets/sound.png";
import sunny from "../assets/summer.png";
import temporary from "../assets/temporary.png";
import winter from "../assets/winter.png";
import Popup from "../common/Popup";
import Table from "../common/Table";
import { apis } from "../config/apis";
import endpoint from "../config/endpoint";
import SelectComponent from "../form-components/Select";
import CartPopup from "./Cart/CartPopup";
import NavBar from "./NavBar";
import { hasOnlyView, getAccessLevel } from "../config/helper";
import { cust_inv_rep } from "../actions/shipmentNPayment";

export const NavWrap = (props) => {
  return (
    <div>
      {!props.noNav && (
        <>
          <NavBar />
          <br />
          <br />
          <br />
          <br />
        </>
      )}
      {props.children}
    </div>
  );
};

export const season_icons = {
  summer: sunny,
  winter: winter,
  "all season": season,
  allseason: season,
  highway: highway,
  classic: classic,
  temporary: temporary,
  "off road": mud,
  "on/off": mud,
};

const getCurrencySymbol = (currency) => (currency === "EUR" ? "€" : "$");

export const TableWrap = (props) => {
  const [activePage, setActivePage] = useState(1);
  const [filterIdx, setFilterIdx] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const history = useHistory();
  const timeOutRef = useRef();
  const { filters, setFilters } = props;
  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
  const isMyOrdersReadOnly = hasOnlyView("claims");
  const { pathname } = useLocation();
  const showIpCodeForTyres = pathname === '/shop-for-tyres';

  useEffect(() => {
    if (!props.searchVal) setSearchVal("");
  }, [props.searchVal]);
  const handleCreatePaginator = useCallback((total, range) => {
    return `Showing ${range[0]} to ${range[1]} of ${total} entires`;
  }, []);
  return (
    <div className="showTyresFilters">
      <div className="flex-between head">
        <h3>
          {props.name}

          {props.namedFilters && props.namedFilters.length > 0 && (
            <span className="named-filters">
              {props.namedFilters.map((ele, i) => {
                return (
                  <span
                    className={
                      i === filterIdx || ele.isActive
                        ? "active cursor"
                        : "cursor"
                    }
                    onClick={() => {
                      ele.action();
                      setFilterIdx(i);
                    }}
                  >
                    {i === 0 ? <span className="mlHalf mrHalf">-</span> : ""}
                    {ele.label}
                  </span>
                );
              })}
            </span>
          )}
        </h3>

        <div className="d-flex">
          {props.showTerms && (
            <button
              className="re-order"
              onClick={() => {
                window.open("terms-and-conditions", "_blank");
              }}
            >
              Terms & Conditions of Sale
            </button>
          )}
          {props.isDateFilter && (
            <div className="filters flex-between ml2 mr2">
              {props.isRange ? (
                <DatePicker.RangePicker
                  onChange={(vals) => {
                    props.onRangeChange(vals);
                    setActivePage(1);
                  }}
                  placeholder={props.rangePlaceholder}
                  disabledDate={(current) => {
                    // Can not select days before today and today
                    return current && current > moment().endOf("day");
                  }}
                />
              ) : (
                <DatePicker />
              )}
            </div>
          )}
          {props.createBtn && (
            <button
              disabled={isMyOrdersReadOnly}
              className="primary-btn mr1 createBtn"
              onClick={() => {
                history.push(props.to);
              }}
            >
              Create {props.createText}
            </button>
          )}
          {props.selectBox && (
            <div className="selectBox ml2 mr2">
              <SelectComponent
                options={props.options}
                placeholder={props.selectPlaceHolder}
                value={props.value}
                onChange={props.onSelect}
                onClear={props.onClear}
                mode={props.mode}
              />
            </div>
          )}
          {!props.isSearch && (
            <div className="search-inline">
             {showIpCodeForTyres && (
              <span
                className="search-label">
                IP CODE:
              </span>
             )}
            <div className="input">
              <img src={Search} alt="search" />
              <input
                placeholder={props.searchPlaceholder}
                onChange={(e) => {
                  if (timeOutRef?.current) {
                    clearTimeout(timeOutRef?.current);
                  }
                  setSearchVal(e.target.value?.trimStart());
                  timeOutRef.current = setTimeout(() => {
                    if (props.callSearch) {
                      setActivePage(1);
                      props.callSearch(e.target.value?.trimStart());
                    }
                  }, 700);
                }}
                id="search-input"
                value={searchVal}
              />
            </div>
            </div>
          )}
          {props.sortKeys?.length > 0 && (
            <Select
              placeholder={"Sort By"}
              className="ml1"
              options={props.sortKeys}
              onChange={(val) => {
                val.value();
              }}
            />
          )}
          {props.showBulk && !props.fromOrder && (
            <button
              disabled={getAccessLevel("new_order") === "view_only"}
              onClick={() => {
                if (getAccessLevel("new_order") === "full_access") {
                  history.push("/create-bulk");
                }
              }}
            >
              Create Bulk Order
            </button>
          )}
          {props.showGrid && (
            <>
              <button
                onClick={() => {
                  props.setGrid && props.setGrid((bool) => !bool);
                }}
              >
                <img src={Menu} alt="menu" />
              </button>
            </>
          )}
          {props.exportComponent}
          {props.isSync && (
            <>
              <button
                onClick={() => {
                  props.sync && props.sync();
                }}
              >
                <span className="sync-text">Sync</span>
                <img src={refresh} alt="menu" className="sync" />
              </button>
            </>
          )}
        </div>
      </div>
      {props.isFilter && (
        <div className="filters flex-between ml2 mr2">
          {props.prod_filters.map((ele) => (
            <SelectComponent
              mode="multiple"
              options={ele.options}
              label={ele.label}
              onChange={(opt) => {
                let fils = { ...filters };
              if (opt?.length > 0) {
                  fils[ele.key] = opt;
                } else {
                  delete fils[ele.key];
                }
                setFilters(fils);
                props.filterCallback(
                  Object.keys(fils).map((key) => ({ [key]: fils[key] }))
                );
              }}
              onClear={() => {
                let fils = { ...filters };
                delete fils[ele.key];
                setFilters(fils);
                props.filterCallback(
                  Object.keys(fils).map((key) => ({ [key]: fils[key] }))
                );
              }}
              value={filters[ele.key]}
            />
          ))}
          <div>
            {/* <button
              className="primary-btn"
              onClick={() => {
                props.filterCallback(
                  Object.keys(filters).map((ele) => ({ [ele]: filters[ele] }))
                );
              }}
            >
              Apply Filter
            </button> */}
          </div>
        </div>
      )}
      {props.children}
      {props.onPageChange && (
        <div
          className={`pagination pb2 ${props.extraBottom ? "extraBottom" : ""}`}
        >
          {props.total_count ? (
            <Pagination
              total={props.total_count}
              pageSize={props.perPageLimit}
              current={activePage}
              onChange={(page, lmt) => {
                setActivePage(page);
                props.onPageChange(page, lmt);
              }}
              showTotal={handleCreatePaginator}
            />
          ) : (
            <span>Showing - of - entries</span>
          )}
        </div>
      )}
    </div>
  );
};

const ShopForTyres = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const prodsData = useSelector((state) => state?.orders?.products);
  const invData = useSelector((state) => state?.orders?.inv_rep?.data);
  const [showTable, setShowTable] = useState(true);
  // const [imgIndex, setImgIndex] = useState({});
  // const imgIndexRef = useRef();
  const [quantityObj, setQuantityObj] = useState({});
  const [loadingObj, setLoadingObj] = useState({});
  // const [orderType, setOrderType] = useState(false);
  const [selectRegion, setSelectRegion] = useState(false);
  const [fromChange, setFromChange] = useState(false);
  const [cartAlert, setCartAlert] = useState(false);
  const [pendingVtweg, setPendingVtweg] = useState(null);
  const [selectAddr, setSelectAddr] = useState(false);
  const deleteFromCart = useSelector((state) => state?.orders?.delFromCart);
  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
  const product_filters = useSelector(
    (state) => state?.orders?.product_filters?.data
  );
  const [filters, setFilters] = useState({});
  const [limit, setLimit] = useState(100);
  const [searchVal, setSearchVal] = useState("");

  const [orderDetails, setOrderDetails] = useState({
    order_type: "FD",
    shipping_address_id: "",
    fd_origin_id: "",
    email: localStorage.getItem("email"),
  });
  const addToCart = useSelector((state) => state?.orders?.addToCart);
  const stored_details = useSelector((state) => state?.orders?.storedOrder);
  const cart = useSelector((state) => state?.orders?.cart?.data?.cart);
  const cart_line_items = useMemo(() => {
    return cart?.line_items?.flatMap((origin) => origin.items) || [];
  }, [cart]);
  const createOrder = useSelector((state) => state?.orders?.createOrder);
  const orderTypeMap = {
    "41": "ftl",
    "10": "fd",
    "43": "ltl",
    "44": "tyreset-4",
  };

  const getOrderType = (vtweg) => orderTypeMap[vtweg] || "fd";


  useEffect(() => {
    if (createOrder.success) {
      dispatch({
        type: CreateOrder.RESET,
      });
    }
    if (createOrder.success === false) {
      dispatch({
        type: CreateOrder.RESET,
      });
    }
    // eslint-disable-next-line
  }, [createOrder]);
  useEffect(() => {
    if (addToCart.success) {
      let obj = {
        email: localStorage.getItem("email"),
      };
      toast.success("Product added to cart.");
      localStorage.setItem("cartId", addToCart?.data?.cart?.id);
      // setQuantityObj({});
      dispatch(get_cart(obj));
      setLoadingObj({});
      dispatch({
        type: AddToCart.RESET,
      });
    }
    if (addToCart.success === false) {
      toast.error("Failed to add product in cart.");
      dispatch({
        type: AddToCart.RESET,
      });
    }
    // eslint-disable-next-line
  }, [addToCart]);

  useEffect(() => {
    if (deleteFromCart.success) {
      toast.success("Deleted Item.");
      dispatch(
        get_cart({
          email: localStorage.getItem("email"),
        })
      );
      if (deleteFromCart?.data?.line_items?.length === 0) {
        history.push("/shop-for-tyres");
      }
      dispatch({
        type: DeleteItemFromCart.RESET,
      });
    }
    if (deleteFromCart.success === false) {
      toast.success("Failed to delete item.");
      dispatch({
        type: DeleteItemFromCart.RESET,
      });
    }
    // eslint-disable-next-line
  }, [deleteFromCart]);
  const regions = useSelector((state) => state?.orders?.origins?.data || []);
  const origin_id =
    localStorage.getItem("orderDetails") || props.origin_id
      ? props.origin_id
        ? props.origin_id
        : JSON.parse(localStorage.getItem("orderDetails"))?.fd_origin_id
      : "";
  const vtweg = stored_details?.vtweg;
  const cartId = localStorage.getItem("cartId");
  const shipAddress = localStorage.getItem("shipping_addresses");
  useEffect(() => {
    if (cartId) {
      let obj = {
        email: localStorage.getItem("email"),
      };
      dispatch(get_cart(obj));
    }

    if (shipAddress) {
      // setOrderType(true);
    } else {
      alert("Please contact your admin. You don't have any shipping addresses");
      history.push("/dashboard");
    }
    // eslint-disable-next-line
  }, [cartId, shipAddress]);

  // Determine default order type based on cart or fallback to FD
  const getDefaultVtweg = () => {
    if (cart_line_items?.length > 0) {
      // If cart exists, take the vtweg of the first line item (assuming all items in cart have same order_type)
      return cart_line_items[0]?.vtweg || "10";
    } else {
      // Fallback to FD if no cart
      return "10";
    }
  };
  const defaultVtweg = getDefaultVtweg();

  useEffect(() => {
    let orderDetails = localStorage.getItem("orderDetails")
      ? JSON.parse(localStorage.getItem("orderDetails"))
      : {};
    let obj = {
      email: localStorage.getItem("email"),
    };
    setOrderDetails((ord) => ({
      ...ord,
      //order_type: defaultVtweg === "41" ? "ftl" : "fd",
      order_type: getOrderType(defaultVtweg),
      vtweg: defaultVtweg,
      ...orderDetails,
    }));
    dispatch(
      store_addr_details({
        ...orderDetails,
        vtweg: defaultVtweg,
        //order_type: defaultVtweg === "41" ? "ftl" : "fd",
        order_type: getOrderType(defaultVtweg),
      })
    );
    if (!prodsData?.data?.products?.length) {
      dispatch(
        get_products({
          ...obj,
          fd_origin_id: origin_id,
          limit,
          vtweg: defaultVtweg || "10", //FD fallback
          page: 1,
        })
      );
    }
    dispatch(get_origins(obj));
    dispatch(get_prod_filters(obj));
    dispatch(get_addresses(obj));

    return () => {
      setQuantityObj({});
      dispatch({
        type: Products.RESET,
      });
      // setOrderType(false);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let obj = {};
    cart_line_items?.forEach((ele) => {
      const product = prodsData?.data?.products?.find(
        (p) => p.sku === ele.SKU &&
        String(p.id) === String(ele.product_id) &&
        String(p.vtweg) === String(ele.vtweg)
     );
    // Always build key the SAME WAY as grid rows
    const sku = ele.SKU;
    const productId = product?.id || ele.product_id || ele.id;
    const vtwegVal = product?.vtweg || ele.vtweg || vtweg;
    const uniqueKey = `${sku}_${productId}_${vtwegVal}`;

        obj[uniqueKey] = ele.Quantity;
        obj[`${uniqueKey}_prod_id`] = productId;
  });

    if (!props.fromOrder) {
    setQuantityObj(obj);
    }
    // eslint-disable-next-line
  }, [cart, prodsData?.data?.products, vtweg]);

  useEffect(() => {
    if (stored_details) {
      if (stored_details.fd_origin_id && stored_details.shipping_address_id) {
        setSelectRegion(false);
      } else {
        setSelectRegion(true);
      }
      setOrderDetails({
        ...orderDetails,
        order_type: stored_details.order_type,
        fd_origin_id: stored_details.fd_origin_id,
        shipping_address_id: stored_details.shipping_address_id,
      });
      localStorage.setItem(
        "orderDetails",
        JSON.stringify({
          ...orderDetails,
          order_type: stored_details.order_type,
          fd_origin_id: stored_details.fd_origin_id,
          vtweg: stored_details.vtweg,
          shipping_address_id: stored_details.shipping_address_id,
        })
      );
    }

    // eslint-disable-next-line
  }, [stored_details]);

  const region = localStorage.getItem("region")?.toLowerCase() === "usa";
  const columns = useMemo(() => {
    let obj = [
      {
        header: "Origin",
        accessor: "oepregion",
        width: 7,
      },
      {
        header: "IP Code",
        accessor: "sku",
        width: 7,
        cell: (row) => row._originalSku || row.sku,  // Display original SKU
      },
      {
        header: "EAN",
        accessor: "ean",
        width: 8,
      },
      {
        header: "Rim",
        accessor: "rim",
        width: 4,
      },
      {
        header: "Size",
        accessor: "size",
        width: 7,
      },
      {
        header: "LI",
        accessor: "li",
        width: 6,
      },
      {
        header: "SR",
        accessor: "sr",
        width: 4,
      },
      {
        header: "LR",
        accessor: "lr",
        width: 3,
      },
      {
        header: "Mark",
        accessor: "mark",
        width: 5,
      },
      {
        header: "SW",
        accessor: "sidewall",
        width: 3,
      },
      {
        header: "Brand",
        accessor: "brand",
        width: 8,
      },
      {
        header: "Pattern",
        accessor: "pattern",
        width: 8,
      },
      {
        header: "Category",
        accessor: "season",
        width: 6,
        cell: (row) => (
          <img
            className={row?.season?.trim()?.toLowerCase()}
            src={season_icons[row?.season?.trim()?.toLowerCase()]}
            width={
              row?.season?.trim()?.toLowerCase() === "classic" ||
              row?.season?.trim()?.toLowerCase() === "off road" ||
              row?.season?.trim()?.toLowerCase() === "temporary"
                ? 20
                : 14
            }
            height={
              row?.season?.trim()?.toLowerCase() === "classic" ||
              row?.season?.trim()?.toLowerCase() === "off road" ||
              row?.season?.trim()?.toLowerCase() === "temporary"
                ? 20
                : 14
            }
            alt="season"
          />
        ),
      },
      {
        header: "Application",
        accessor: "application",
        width: 6,
      },
      region
        ? {}
        : {
            header: <img src={fuel} width={14} height={14} alt="season" />,
            accessor: "fe",
            width: 3,
          },
      region
        ? {}
        : {
            header: <img src={rain} width={14} height={14} alt="season" />,
            accessor: "wg",
            width: 3,
          },
      region
        ? {}
        : {
            header: <img src={no_sound} width={16} height={14} alt="season" />,
            accessor: "ernc",
            width: 3,
          },
      region
        ? {
            header: "UTQG",
            accessor: "zmutqg",
            width: 4,
          }
        : {
            header: <img src={sound} width={16} height={14} alt="season" />,
            accessor: "ern",
            width: 4,
          },
      {
        header: <img src={peak} width={22} height={18} alt="season" />,
        accessor: "wr",
        width: 4,
      },
      {
        header: "Unit Price",
        accessor: "unit_price",
        cell: (row) =>
          `${getCurrencySymbol(row.currency)}${parseFloat(
            row.unit_price
          ).toFixed(2)}`,
        width: 6,
      },
      // {
      //   header: "Available Qty",
      //   accessor: "sku",
      //   cell: (row) =>
      //     invData?.find(
      //       (ele) => ele?.Matnr === row.sku && row.vtweg === ele?.Vtweg
      //     )?.AvailImmC,
      //   width: 6,
      // },
    ];

    return obj;
    // eslint-disable-next-line
  }, [stored_details, region, invData]);

  const prod_filters = useMemo(
    () => [
      {
        label: "Origin",
        options: product_filters?.oepregion
          ? product_filters?.oepregion
              ?.sort()
              ?.map((ele) => ({ label: ele, value: ele }))
          : [],
        key: "oepregion",
      },
      // {
      //   label: "Origin",
      //   options: product_filters?.oepregion
      //     ? product_filters.oepregion
      //         .sort((a, b) => a[0].localeCompare(b[0]))
      //         .map(([name, code]) => ({
      //           label: name.trim(),
      //           value: name.trim(), // or `${name}-${code}`
      //           vtweg: code, // optional
      //         }))
      //     : [],
      //   key: "oepregion",
      // },
      {
        label: "Brand",
        options: product_filters?.brand
          ? product_filters?.brand
              ?.sort()
              ?.map((ele) => ({ label: ele, value: ele }))
          : [],
        key: "brand",
      },
      {
        label: "Pattern",
        options: product_filters?.pattern
          ? product_filters?.pattern?.sort()?.map((ele) => ({
              label: ele,
              value: ele,
            }))
          : [],
        key: "pattern",
      },
      {
        label: "Size",
        options:  product_filters?.size?.sort()?.map((ele) => ({
          label: ele,
          value: ele,
        })) || [],
        key: "size",
      },
      {
        label: "Rim Size",
        options: product_filters?.rim
          ? product_filters?.rim
              ?.sort()
              ?.map((ele) => ({ label: ele, value: ele }))
          : [],
        key: "rim",
      },
      {
        label: "Speed Rating",
        options: product_filters?.sr
          ? product_filters?.sr
              ?.sort()
              ?.map((ele) => ({ label: ele, value: ele }))
          : [],
        key: "sr",
      },
      {
        label: "Load Rating",
        options: product_filters?.lr
          ? product_filters?.lr
              ?.sort()
              ?.map((ele) => ({ label: ele, value: ele }))
          : [],
        key: "lr",
      },
      {
        label: "Category",
        options: product_filters?.season
          ? product_filters?.season
              ?.sort()
              ?.map((ele) => ({ label: ele, value: ele }))
          : [],
        key: "season",
      },
      {
        label: "Application",
        options: product_filters?.application
          ? product_filters?.application?.sort()?.map((ele) => ({
              label: ele,
              value: ele,
            }))
          : [],
        key: "application",
      },
    ],
    [product_filters]
  );

  const sortedFileNames = (a, b) => {
    // Extract numeric parts and convert to integers
    let numA = parseInt(a?.name?.match(/\d+/)?.[0], 10);
    let numB = parseInt(b?.name?.match(/\d+/)?.[0], 10);

    return numA - numB;
  };

    const switchOrderType = (newVtweg) => {
      if (cart_line_items && cart_line_items.length > 0) {
        setPendingVtweg(newVtweg);
        setCartAlert(true);
        return;
      }
      executeOrderTypeSwitch(newVtweg);
    };
    const executeOrderTypeSwitch = (vtweg) => {
      const cartId= localStorage.getItem("cartId");
      if(cartId){
        dispatch(clear_cart({cartId}));
        localStorage.removeItem("cartId");
      }
      const order_type = getOrderType(vtweg);
    // Update redux + localStorage
    dispatch(
      store_addr_details({
        ...stored_details,
        vtweg,
        order_type,
      })
    );

    localStorage.setItem(
      "orderDetails",
      JSON.stringify({
        ...stored_details,
        vtweg,
        order_type,
      })
    );

    // Fetch products
    dispatch(
      get_products({
        email: localStorage.getItem("email"),
        page: 1,
        limit,
        fd_origin_id: stored_details.fd_origin_id,
        vtweg,
        ...filters,
        ...(searchVal && { search: searchVal }),
      })
    );
    dispatch(get_prod_filters({
      email: localStorage.getItem("email"),
      vtweg,
    }));
  };

  return (
    <>
      <div className="shop-tyres">
        {/* !origin_id && props.fromOrder ? (
          <SelectRegion
            setSelectRegion={setSelectRegion}
            limit={limit}
            setSelectAddr={setSelectAddr}
            setOrderDetails={setOrderDetails}
            orderDetails={stored_details}
            noBack={true}
          />
        ) : ( */}
          <NavWrap noNav={props.noNav}>
            <CartPopup />
            <TableWrap
              prod_filters={prod_filters}
              filters={filters}
              setFilters={setFilters}
              searchVal={searchVal}
              isFilter={true}
              showBulk={true}
              fromOrder={props.fromOrder}
              bulkpath={"/create-bulk"}
              name={
                !props.fromOrder && (
                  <span style={{ display: "flex", alignItems: "center" }}>
                    Order Type:

                    <span className="order-type-filter">                 

                    {/* FD */}
                    <label>
                      <input
                        type="radio"
                        name="orderType"
                        checked={(stored_details?.vtweg ?? "10") === "10"}
                        onChange={() => switchOrderType("10")}
                      />
                      <span title="Factory Direct">FD</span>
                    </label>

                    {/* FTL */}
                    {/* <label>
                      <input
                        type="radio"
                        name="orderType"
                        checked={stored_details?.vtweg === "41"}
                        onChange={() => switchOrderType("41")}
                      />
                      <span title="Full Truck Load">FTL</span>
                    </label> */}
                    {/* LTL */}
                    {/* <label>
                      <input
                        type="radio"
                        name="orderType"
                        checked={stored_details?.vtweg === "43"}
                        onChange={() => switchOrderType("43")}
                      />
                      <span title="Less Than Truck Load">LTL</span>
                    </label> */}
                    {/* 4-TIRES */}
                    {/* <label>
                      <input
                        type="radio"
                        name="orderType"
                        checked={stored_details?.vtweg === "44"}
                        onChange={() => switchOrderType("44")}
                      />
                      <span title="Tyre Set-4">TyreSet-4</span>
                    </label> */}
                  </span>
                  </span>
                )
              }
              showGrid={!props.fromOrder}
              setGrid={setShowTable}
              extraBottom={Object.keys(quantityObj).length > 2}
              searchPlaceholder={"Search by IP Code"}
              total_count={prodsData?.data?.pagination?.total_count}
              perPageLimit={limit}
              onPageChange={(page, lmt) => {
                let obj = {
                  email: localStorage.getItem("email"),
                };
                if (searchVal) {
                  obj.search = searchVal;
                }
                setLimit(lmt);
                dispatch(
                  get_products({
                    ...obj,
                    ...filters,
                    page: page,
                    limit: lmt,
                    fd_origin_id: origin_id,
                    vtweg,
                    filters: Object.keys(filters).length > 0 ? true : false,
                  })
                );
              }}
              callSearch={(search) => {
                let obj = {
                  email: localStorage.getItem("email"),
                };
                dispatch(
                  get_products({
                    ...obj,
                    page: 1,
                    limit,
                    search,
                    vtweg,
                    fd_origin_id: props.fromOrder
                      ? props.origin_id
                      : stored_details.fd_origin_id,
                    ...filters,
                    filters: true,
                  })
                );
                setSearchVal(search);
              }}
              filterCallback={(fils) => {
                let obj = {
                  email: localStorage.getItem("email"),
                };
                let filterObj = {};
                fils.forEach((ele) => {
                  filterObj = {
                    ...filterObj,
                    ...ele,
                  };
                });
                if (searchVal) {
                  obj.search = searchVal;
                }
                dispatch(
                  get_products({
                    ...obj,
                    page: 1,
                    limit,
                    ...filterObj,
                    filters: true,
                    vtweg,
                    fd_origin_id: props.fromOrder
                      ? props.origin_id
                      : stored_details.fd_origin_id,
                  })
                );
              }}
            >
              {showTable ? (
                <Table
                  columns={columns}
                  data={
                    prodsData?.data?.products 
                      ? prodsData?.data?.products.map((product, index) => ({
                          ...product,
                          sku: `${product.sku}_${product.id}_${product.vtweg}`,  // Make SKU unique by adding ID
                          _originalSku: product.sku,  // Keep original for API calls
                          _productIndex: index,  // For tracking
                        })) 
                      : []
                  }
                  action={true}
                  actionText={"Order Quantity"}
                  actionWidth={7}
                  orderDetails={orderDetails}
                  quantityObj={quantityObj}
                  setQuantityObj={setQuantityObj}
                  fromCart={
                    props.fromOrder ? false : cart_line_items.length > 0
                  }
                  addToCart={(item) => {
                    const productId = item._originalSku 
                    ? quantityObj[`${item.sku}_prod_id`] 
                    : quantityObj[`${item.sku}_prod_id`];
    
                    let obj = {
                      ...orderDetails,
                      product_id: productId || item.id,
                      quantity: quantityObj[item.sku],
                      email: localStorage.getItem("email"),
                      //order_type: vtweg == "41" ? "ftl" : "fd",
                      order_type: getOrderType(vtweg),
                    };
                    if (localStorage.getItem("cartId")) {
                      obj.cart_id = localStorage.getItem("cartId");
                    }
                    if (props.fromOrder) {
                      props.fromOrderCart({ ...item, product_id: item.id });
                      setQuantityObj({});
                      toast.success("Product added to order.");
                    } else {
                      dispatch(add_to_cart(obj));
                    }
                  }}
                  addAllToCart={() => {
                    let rows = Object.keys(quantityObj)?.filter(
                      (ele) =>
                        !ele.includes("prod_id") &&
                        !cart_line_items.find(
                          (itm) =>
                            itm.SKU === ele && quantityObj[ele] === itm.Quantity
                        )
                    );
                    if (rows.length > 0) {
                      let obj = {
                        email: localStorage.getItem("email"),
                      };
                      if (localStorage.getItem("cartId")) {
                        obj.cart_id = localStorage.getItem("cartId");
                      }
                      if (obj.cart_id) {
                        rows.forEach((ele, index) => {
                          obj = {
                            ...orderDetails,
                            product_id: quantityObj[`${ele}_prod_id`],
                            quantity: quantityObj[ele],
                            cart_id: obj.cart_id,
                            email: localStorage.getItem("email"),
                            //order_type: vtweg == "41" ? "ftl" : "fd",
                            order_type: getOrderType(vtweg),
                          };
                          endpoint
                            .post(apis.line_items, obj)
                            .then((res) => {
                              // if (localStorage.getItem("cartId") != res.data.cart.id) {
                              //   localStorage.setItem("cartId", res.data.cart.id);
                              // }
                              if (index === rows.length - 1) {
                                setQuantityObj({});
                                toast.success("Items Added to cart");
                                dispatch(
                                  get_cart({
                                    email: localStorage.getItem("email"),
                                  })
                                );
                              }
                            })
                            .catch((err) => {
                              toast.error(
                                "Failed to add item into cart with SKU: " + ele
                              );
                            });
                        });
                      } else {
                        console.log("new", { vtweg });

                        obj = {
                          ...obj,
                          ...orderDetails,
                          product_id: quantityObj[`${rows[0]}_prod_id`],
                          quantity: quantityObj[rows[0]],
                          email: localStorage.getItem("email"),
                          //order_type: vtweg == "41" ? "ftl" : "fd",
                          order_type: getOrderType(vtweg),
                        };
                        rows.splice(0, 1);

                        endpoint.post(apis.line_items, obj).then((res) => {
                          let cart_id = res?.data?.cart?.id;
                          localStorage.setItem("cartId", res?.data?.cart?.id);
                          rows.forEach((ele, index) => {
                            obj = {
                              ...orderDetails,
                              product_id: quantityObj[`${ele}_prod_id`],
                              quantity: quantityObj[ele],
                              cart_id,
                              email: localStorage.getItem("email"),
                              //order_type: vtweg == "41" ? "ftl" : "fd",
                              order_type: getOrderType(vtweg),
                            };
                            endpoint
                              .post(apis.line_items, obj)
                              .then((res) => {
                                if (index === rows.length - 1) {
                                  setQuantityObj({});
                                  toast.success("Items Added to cart");
                                  dispatch(
                                    get_cart({
                                      email: localStorage.getItem("email"),
                                    })
                                  );
                                }
                              })
                              .catch((err) => {
                                toast.error(
                                  "Failed to add item into cart with SKU: " +
                                    ele
                                );
                              });
                          });
                        });
                      }
                    }
                  }}
                  onRowClick={(row) => {
                    if (!props.fromOrder) {
                      history.push("/product-detail", {
                        product: row,
                        orderDetails,
                      });
                    }
                  }}
                  showMulti={true}
                  lineItems={
                    props.fromOrder ? props.line_items : cart_line_items
                  }
                  fromOrder={props.fromOrder}
                  delete={(id) => {
                    dispatch(
                      del_from_cart({
                        id,
                        email: localStorage.getItem("email"),
                      })
                    );
                  }}
                  loading={prodsData?.loading}
                  price_loading={prodsData?.loading}
                  orderType={stored_details?.order_type}
                />
              ) : prodsData?.loading ? (
                <div
                  className="mt2 mb2"
                  style={{
                    height: "15rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <div>
                    <ScaleLoader color={"#2f2d51"} />
                  </div>
                  {prodsData?.loading && (
                    <p style={{ color: "#2f2d51", fontWeight: 600 }}>
                      Loading...
                    </p>
                  )}
                </div>
              ) : (
                <div className="d-grid pt2 pb2 orders-grid">
                  {prodsData?.data &&
                    prodsData?.data?.products?.length > 0 &&
                    prodsData?.data?.products?.map((ele) => {
                      // 1. Define the unique key for this specific product + order type
                      const uniqueGridKey = `${ele.sku}_${ele.id}_${ele.vtweg}`;
                      // 2. Check if this specific product/vtweg combo is already in the cart
                      const isInCart = cart_line_items.find(
                            (item) =>
                              item.SKU === ele._originalSku &&
                              item.product_id === ele.id &&
                              item.vtweg === ele.vtweg
                          );
                          const getRowKey = (row) =>
                                 `${row._originalSku}_${row.id}_${row.vtweg}`;

                      return (
                        <div
                          className="item"
                          key={uniqueGridKey} // Adding a key for React rendering
                          onClick={() => {
                            history.push("/product-detail", {
                              product: ele,
                              orderDetails: orderDetails,
                            });
                          }}
                        >
                          <div className="flex-center mt2 mb1 img-wrap">
                            <img
                              src={
                                ele.images?.length
                                  ? ele?.images?.sort(sortedFileNames)?.[0]?.url
                                  : Tyre
                              }
                              width={150}
                              alt="type"
                              // onMouseEnter={() => {
                              //   if (ele.images?.length > 0) {
                              //     imgIndexRef.current = setInterval(() => {
                              //       setImgIndex(i => ({ [ele.id]: ((i || 0) + 1) % ele.images?.length }))
                              //     }, 200)
                              //   }
                              // }} onMouseLeave={() => {
                              //   if (imgIndexRef.current) {
                              //     clearInterval(imgIndexRef.current)
                              //     setImgIndex(0)
                              //   }
                              // }}
                            />
                          </div>
                          <div className="ml1 mr1 mb1">
                            <div className="flex-between light">
                              <span>{ele.size}</span>
                              <span>{ele.sku}</span>
                            </div>
                            <div className="flex-between bold">
                              <span>{ele.pattern}</span>
                              <span>
                                {getCurrencySymbol(ele.currency)}
                                {parseFloat(ele.unit_price).toFixed(2)}
                              </span>
                            </div>
                            <div className="flex-between light o5">
                              <span>{ele.brand}</span>
                              <span>
                                {ele.li} / {ele.sr} / {ele.lr}
                              </span>
                            </div>
                            <div
                              className="td action-td w100"
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <input
                                // 3. Use the uniqueGridKey to retrieve quantity
                                value={quantityObj[uniqueGridKey] || ""}
                                onChange={(e) => {
                                  if (
                                    e.target.value === "" ||
                                    new RegExp("^[0-9]+$").test(e.target.value)
                                  ) {
                                    setQuantityObj({
                                      ...quantityObj,
                                      [uniqueGridKey]: e.target.value,
                                    });
                                  } else {
                                    e.target.value !== "" &&
                                      alert("Enter valid quantity");
                                  }
                                }}
                              />
                              <button
                                disabled={getAccessLevel("new_order") === "view_only"}
                                className={
                                  loadingObj[ele.id]
                                    ? "loadBtn"
                                    : quantityObj[uniqueGridKey] > 0 && isInCart
                                    ? "bg-green"
                                    : ""
                                }
                                onClick={() => {
                                  if (getAccessLevel("new_order") === "full_access") {
                                  setLoadingObj({
                                    [ele.id]: true,
                                  });
                                  let obj = {
                                    ...orderDetails,
                                    product_id: ele.id,
                                    quantity: quantityObj[uniqueGridKey],
                                    //order_type: vtweg == "41" ? "ftl" : "fd",
                                    order_type: getOrderType(ele.vtweg),
                                  };
                                  if (localStorage.getItem("cartId")) {
                                    obj.cart_id =
                                      localStorage.getItem("cartId");
                                  }
                                  dispatch(add_to_cart(obj));
                                }
                                }}
                              >
                                {loadingObj[ele.id]
                                  ? "Adding to cart"
                                  : quantityObj[uniqueGridKey] > 0 && isInCart
                                  ? "Added to cart"
                                  : "Add to cart"}
                              </button>
                              {/* 4. Delete button logic using isInCart check */}
                              {quantityObj[uniqueGridKey] > 0 && isInCart && (
                                  <img
                                    className="cancel mlHalf"
                                    src={close}
                                    alt={"close"}
                                    width={14}
                                    onClick={() =>
                                      dispatch(
                                        del_from_cart({
                                          id: isInCart.id,
                                          email: localStorage.getItem("email"),
                                        })
                                      )
                                    }
                                  />
                                )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}
            </TableWrap>
          </NavWrap>
        {/* )} */}
        {/* <Popup open={orderType && !props.fromOrder}>
        <OrderType
          setOrderType={setOrderType}
          setSelectRegion={setSelectRegion}
          setOrderDetails={setOrderDetails}
          setSelectAddr={setSelectAddr}
        />
      </Popup> */}
      </div>
      {/* <Popup
        open={selectRegion && !props.fromOrder}
        height={280}
        className="origin"
      >
        <SelectRegion
          setSelectRegion={setSelectRegion}
          setSelectAddr={setSelectAddr}
          setOrderDetails={setOrderDetails}
          orderDetails={stored_details}
          limit={limit}
          onBack={() => {
            // setOrderType(true);
            if (origin_id) {
              setSelectRegion(false);
              setFromChange(false);
            } else {
              history.push("/dashboard");
            }
          }}
          noBack={fromChange}
          clearCart={origin_id}
        />
      </Popup> */}
      {/* <Popup open={selectAddr && !props.fromOrder}>
        <DestinationAddr
          setSelectAddr={setSelectAddr}
          setOrderDetails={setOrderDetails}
          orderDetails={stored_details}
          onBack={() => {
            setSelectRegion(true);
            setSelectAddr(false);
          }}
        />
      </Popup> */}
      <Popup open={cartAlert}>
        <div className="popup-wrap">
          <h2>
            Changing the Order Type will clear your existing cart, Do you want to continue
            ?
          </h2>
          <div className="btns mt1">
            <button
              className="cancel-btn mr2"
              onClick={() => {
                setCartAlert(false);
                setPendingVtweg(null);
              }}
            >
              Cancel
            </button>
            <button
              className="save-btn"
              onClick={() => {
                const cartId = localStorage.getItem("cartId");
                dispatch(clear_cart({ cartId }));
                localStorage.removeItem("cartId");
                dispatch({
                  type: GetCart.RESET });
              if (pendingVtweg) {
                executeOrderTypeSwitch(pendingVtweg);
                setPendingVtweg(null);
              } else {
                setSelectRegion(true);
              }
                setFilters({});
                setCartAlert(false);
                setSearchVal("");
              }}
            >
              Ok
            </button>
          </div>
        </div>
      </Popup>
    </>
  );
};

// const SelectRegion = ({
//   setSelectRegion,
//   setSelectAddr,
//   setOrderDetails,
//   orderDetails,
//   noBack,
//   clearCart,
//   onBack,
//   limit,
// }) => {
//   const regions = useSelector((state) =>
//     Array.isArray(state?.orders?.origins?.data)
//       ? state?.orders?.origins?.data
//           ?.filter((ele) => ele.name)
//           ?.map((ele) => ({
//             label: ele.name,
//             value: ele.id,
//             vtweg: ele.vtweg,
//           }))
//       : []
//   );
//   const dispatch = useDispatch();
//   return (
//     <div className="popup-wrap">
//       <span className="close" onClick={onBack}>
//         <img
//           src={close}
//           alt="close"
//           className="cursor"
//           style={{ width: "1rem" }}
//         />
//       </span>
//       <h2>Please select the Origin</h2>
//       <div className="flex-center flex-col">
//         <section className="w80 mt1 mb1">
//           <Select
//             options={
//               Array.isArray(regions)
//                 ? regions?.sort((a, b) => a.label?.localeCompare(b.label))
//                 : []
//             }
//             onChange={(e) => {
//               setOrderDetails((ord) => ({
//                 ...ord,
//                 fd_origin_id: e.value,
//                 vtweg: e.vtweg,
//                 order_type: e.vtweg === "41" ? "ftl" : "fd",
//               }));
//               dispatch(
//                 store_addr_details({
//                   fd_origin_id: e.value,
//                   vtweg: e.vtweg,
//                   shipping_address_id: "",
//                   order_type: e.vtweg === "41" ? "ftl" : "fd",
//                 })
//               );
//               if (clearCart && clearCart !== e.value) {
//                 localStorage.removeItem("cartId");
//                 dispatch({
//                   type: GetCart.RESET,
//                 });
//               }
//               dispatch(
//                 get_products({
//                   email: localStorage.getItem("email"),
//                   page: 1,
//                   limit,
//                   fd_origin_id: e.value,
//                   vtweg: e.vtweg,
//                 })
//               );
//             }}
//             value={regions?.find(
//               (ele) => ele.value === orderDetails?.fd_origin_id
//             )}
//           />
//         </section>
//         <span className="note w80">
//           Note : Please select the region of origin from which the order has to
//           be dispatched.
//         </span>
//       </div>
//       <div className="btns mt1">
//         {noBack && (
//           <button className="cancel-btn mr2" onClick={onBack}>
//             Back
//           </button>
//         )}
//         <button
//           className="save-btn"
//           onClick={() => {
//             setSelectRegion(false);
//             setSelectAddr(true);
//           }}
//           disabled={!orderDetails?.fd_origin_id}
//         >
//           Proceed
//         </button>
//       </div>
//     </div>
//   );
// };

// const DestinationAddr = ({
//   setSelectAddr,
//   setOrderDetails,
//   orderDetails,
//   onBack,
// }) => {
//   console.log({ orderDetails });

//   const addresses = useSelector((state) =>
//     Array.isArray(state?.orders?.addresses?.data)
//       ? state?.orders?.addresses?.data
//           ?.filter((ele) => ele.vtweg === orderDetails.vtweg)
//           ?.map((ele) => ({
//             label: `${ele.city}, Pincode: ${ele.zip}`,
//             value: ele.id,
//           }))
//       : []
//   );
//   const dispatch = useDispatch();
//   return (
//     <div className="popup-wrap">
//       <span className="close" onClick={onBack}>
//         <img
//           src={close}
//           alt="close"
//           className="cursor"
//           style={{ width: "1rem" }}
//         />
//       </span>
//       <h2>Select destination address</h2>
//       <div className="flex-center flex-col">
//         <section className="w80 mt1 mb1">
//           <Select
//             options={addresses}
//             onChange={(e) => {
//               setOrderDetails((ord) => ({
//                 ...ord,
//                 shipping_address_id: e.value,
//               }));
//               dispatch(
//                 store_addr_details({
//                   shipping_address_id: e.value,
//                 })
//               );
//             }}
//             value={addresses.find(
//               (ele) => ele.value === orderDetails?.shipping_address_id
//             )}
//           />
//         </section>
//         <span className="note w80">
//           Note : Please select the destination address to which the order has to
//           delivered.
//         </span>
//       </div>
//       <div className="btns mt1">
//         <button className="cancel-btn mr2" onClick={onBack}>
//           Back
//         </button>
//         <button
//           className="save-btn"
//           onClick={() => {
//             setSelectAddr(false);
//           }}
//           disabled={!orderDetails?.shipping_address_id}
//         >
//           Proceed
//         </button>
//       </div>
//     </div>
//   );
// };

export default ShopForTyres;
